export default __webpack_public_path__ + "static/media/pic112.e519a62c.jpg";